import vcBacktop from './Backtop'

module.exports = vcBacktop



// WEBPACK FOOTER //
// ./src/main.js